import { render, staticRenderFns } from "./DataSourcesPage.vue?vue&type=template&id=d0d21484&scoped=true&"
import script from "./DataSourcesPage.vue?vue&type=script&lang=ts&"
export * from "./DataSourcesPage.vue?vue&type=script&lang=ts&"
import style0 from "./DataSourcesPage.vue?vue&type=style&index=0&id=d0d21484&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d21484",
  null
  
)

export default component.exports